<template>
  <div id="app">
    <div class="header">
        <div class="home" @click="showHome"><img src="../assets/buttons/homeknop.png" alt="home"></div>
      <div class="sensors">
          <img v-if="qrActive" src="/assets/buttons/qr-button-diap.png" alt="QR Scanner" @click="showQR">
          <img v-if="groupsActive" src="/assets/buttons/list-button-diap.png" alt="Group Buttons" @click="showGroups">
      </div>
        <img class="buttonboard" v-if="bbActive" src="../assets/buttons/button-buttonboard.svg" alt="Subject Buttons" @click="showBB">
    </div>
    <div class="objectlist-container">
    </div>
    <center>
        <h1 class="audio-code">{{ codeToSend }}</h1>
        <div class="keyboard-container">
            <div class="key" @click="press('1')"><img src="../assets/buttons/key-1.svg"></div>
            <div class="key" @click="press('2')"><img src="../assets/buttons/key-2.svg"></div>
            <div class="key" @click="press('3')"><img src="../assets/buttons/key-3.svg"></div>
            <div class="key" @click="press('4')"><img src="../assets/buttons/key-4.svg"></div>
            <div class="key" @click="press('5')"><img src="../assets/buttons/key-5.svg"></div>
            <div class="key" @click="press('6')"><img src="../assets/buttons/key-6.svg"></div>
            <div class="key" @click="press('7')"><img src="../assets/buttons/key-7.svg"></div>
            <div class="key" @click="press('8')"><img src="../assets/buttons/key-8.svg"></div>
            <div class="key" @click="press('9')"><img src="../assets/buttons/key-9.svg"></div>
            <div class="key" @click="press('-')"><img src="../assets/buttons/key-correction.svg"></div>
            <div class="key" @click="press('0')"><img src="../assets/buttons/key-0.svg"></div>
            <div class="key" @click="press('+')"><img src="../assets/buttons/key-start.svg"></div>
        </div>
    </center>
    <div class="footer">
      <hr>
      <div class="copy-right">&copy; Easycast Audio Tour</div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import router from '../router';
let codeToSend = '00';
export default {
  name: 'KeyPad',
  components: {
  },
  props: ['langId'],
  data() {
    return {
        codeToSend,
        apiUrl: null,
        apiKey: null,
        apiCollection: null,
        qrActive: false,
        bbActive: false,
        groupsActive: false,
        languageX: ''
    }
  },
  methods: {
    showHome: function() {
      router.push('/');
    },
    showWelcome: function() {
      router.push('/welcome/' + this.langId);
    },
    showIntro: function() {
      router.push('/intro/' + this.langId);
    },
    showQR: function() {
      router.push('/qr/'+this.langId);
    },
    showBB: function() {
      router.push('/buttons/'+this.langId);
    },
    showGroups: function() {
      router.push('/groups/'+this.langId);
    },
    handleCode(codeIn) {
        const codeSearch = 'audio-' + codeIn;
        console.log('axios query: ' + this.apiUrl + 'items?tags='+codeSearch+'&collection=' + this.apiCollection + '&key=' + this.apiKey);
        axios.get(this.apiUrl + 'items?tags='+codeSearch+'&collection=' + this.apiCollection + '&key=' + this.apiKey)
          .then((res) => {
            var objectId = res.data[0].id;
            router.push('/object/'+this.langId+'/'+objectId);
            }
          )
          .catch(err => console.log(err));
    },
    press(keyIn) {
        // console.log(keyIn);
        if(keyIn === '+') {
            console.log('gaan!');
            if(this.codeToSend !== '00' && this.codeToSend.length === 2) {
                this.handleCode(this.codeToSend);
            }
        }
        else if(keyIn === '-') {
            console.log('wis!');
            if(this.codeToSend.length <= 1) {
                this.codeToSend = '00';
            } else {
                this.codeToSend = this.codeToSend.slice(0,-1);
            }
        } else {
            if(this.codeToSend === '00') {
                this.codeToSend = keyIn;
            } else {
                if(this.codeToSend.length < 2) {
                this.codeToSend = this.codeToSend + keyIn;
                }
            }
        }
    }
  },
  created() {
      axios.get('/config/app.json')
      .then((res) => {
        let configData = res.data;
        this.qrActive = configData.qrscanner;
        this.bbActive = configData.buttonboard;
        this.groupsActive = configData.groups;
        this.apiUrl = configData.api;
        this.apiKey = configData.api_key;
        this.apiCollection = configData.api_collection;
        this.languageX = configData.language_x;
      })
      .catch((err) => { console.log('error config: ' + err) });
  }
}
</script>

<style>
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }
  body {
    font-family: 'robotoregular', Arial, Helvetica, sans-serif;
    line-height: 1.4;
  }
  .header .home {
      position: absolute;
      padding: 5px;
      height: 80px;
      top: 15px !important;
      left: 4%;
      z-index: 999;
  }
  .header .home img {
      height: 55px;
      width: auto;
  }
  .header .sensors {
      position: absolute;
      padding: 5px;
      height: 70px;
      width: 100%;
      top: 0px;
      text-align: center;
  }
  .header .sensors img {
      height: 50px;
      width: auto;
      /*margin-right: 30px;*/
  }
  .header .sensors img.btn-keypad {
      height: 50px;
      width: auto;
      margin-right: 0;
      margin-top: 16px;
  }
  .header .buttonboard {
      position: absolute;
      right: 7%;
      top: 22px;
      width: auto;
      height: 40px;
  }
.keyboard-container {
    display: flex;
    flex-wrap: wrap;
    /*flex-direction: row;*/
    justify-content: center;
    /*align-items: center;*/
    /*text-align: center;*/
    width: 70%;
    max-width: 600px;
    height: fit-content;
}
.keyboard-container .key {
    display:inline-flex;
    width: 28%;
     padding: 1%;
    font-family: 'robotobold', 'Courier New', Courier, monospace;
    font-size: 25px;
    font-weight: bold;
    color: black;
    text-align: center;
    vertical-align: middle;
    margin: 5px;
}

  .keyboard-container .key img {
      width: 100%;
      height: 100%;
  }

  .objectlist-container {
    position: absolute;
    top: 120px;
    color: white;
  }
  .audio-code {
          margin-top: 80px;
          margin-bottom: 10px;
          color: white;
      font-family: adelleregular;
      font-size: 3em;
  }
  .footer {
      position: fixed;
      bottom: 0;
      width: 100%;
      padding-left: 0% !important;
      padding-right: 0% !important;
      color: white;
      text-align: center;
      background-color: #2e368b !important;
  }
  .copy-right {
    padding-top: 6px;
    padding-bottom: 6px;
  }
</style>
